import { createContext } from 'react';
import { PLP_TYPE, PAGE_TYPE } from '@yme/common/constants';
import { EXTRA_MENU_TYPE } from '@yme/components/Header/constants';
export const MenuContext = createContext({
    prevs: [],
    initialChildren: {
        title: '',
        items: [],
        pageType: '',
    },
    children: {
        title: '',
        items: [],
        pageType: '',
    },
    parentType: '',
    setPrevs: () => ({}),
    setPrevPages: () => ({}),
    returnToPrev: () => ({}),
    setMenuChildren: () => ({}),
    setParentPageType: () => ({}),
    setNavButtonsContent: () => ({}),
    navButtonsContent: {
        [PLP_TYPE]: {
            title: '',
            link: '',
        },
        [EXTRA_MENU_TYPE]: {
            title: '',
            link: '',
        },
        [PAGE_TYPE]: {
            title: '',
            link: '',
        },
    },
});
